import { fromEvent, Subscription } from 'rxjs';
import { debounceTime, takeWhile, throttleTime } from 'rxjs/operators';

export type VerticalDragDirection =
    'draggingDown' |
    'draggingUp' |
    'notDragging';

export class MouseDragTracker {

    private _prevMouseY = null;

    private _isAlive = true;

    private _mouseMoveSub: Subscription;
    private _mouseUpSub: Subscription;

    significantMoveThresholdPx = 2;
    throttleTimeMs = 50;
    debounceTimeMs = 20;

    verticalDragDirection: VerticalDragDirection = 'notDragging';

    startTracking(): void {
        this._mouseMoveSub = fromEvent<MouseEvent>(document, 'mousemove').pipe(
            takeWhile(() => this._isAlive),
            throttleTime(this.throttleTimeMs),
            debounceTime(this.debounceTimeMs)
        ).subscribe(event => {
            this.handleMouseMove(event);
        });
        this._mouseUpSub = fromEvent<MouseEvent>(document, 'mouseup').pipe(
            takeWhile(() => this._isAlive)
        ).subscribe(() => {
            this.stopTracking();
        });
    }

    private handleMouseMove(mouseEvent: MouseEvent): void {
        if (!this._prevMouseY) {
            this._prevMouseY = mouseEvent.clientY;
            return;
        }
        if (!this.isMoveSignificant(mouseEvent)) {
            return;
        }

        if (mouseEvent.clientY > this._prevMouseY) {
            this.verticalDragDirection = 'draggingDown';
        }
        else if (mouseEvent.clientY < this._prevMouseY) {
            this.verticalDragDirection = 'draggingUp';
        }

        this._prevMouseY = mouseEvent.clientY;
    }
    private isMoveSignificant(mouseEvent: MouseEvent): boolean {
        const deltaY = Math.abs(mouseEvent.clientY - this._prevMouseY);
        return deltaY > this.significantMoveThresholdPx;
    }
    private stopTracking(): void {
        this.verticalDragDirection = 'notDragging';
        this._prevMouseY = null;
        this._mouseMoveSub?.unsubscribe();
        this._mouseUpSub?.unsubscribe();
    }

    destroy(): void {
        this.stopTracking();
        this._mouseMoveSub = null;
        this._mouseUpSub = null;
    }
}
